import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ColorScale } from '@models/mood/general/color_scale';
import { ColorScaleConfig } from '@models/mood/dataset';
import { Observable, map, startWith } from 'rxjs';
import { ColorScaleService } from 'src/app/core/color-scale.service';


export interface ColorScaleForm {
  scale_id: FormControl<string | null>;
  invert: FormControl<boolean | null>;
}

@Component({
  selector: 'mood-admin-color-scale-form',
  templateUrl: './color-scale-form.component.html',
  styleUrls: [
    'color-scale-form.component.scss'
  ]
})
export class ColorScaleFormComponent implements OnInit {
  @Input() rasterLayerConfiguration!: ColorScaleConfig;


  colorScales: ColorScale[] = [];

  constructor(private _controlContainer: ControlContainer, private _colorScaleService: ColorScaleService) { }

  get formGroupContainer() {
    return this._controlContainer.control as FormGroup<ColorScaleForm>;
  }

  colorScaleControl = new FormControl<string | ColorScale>('');
  filteredColorScales?: Observable<ColorScale[]>;

  async ngOnInit() {
    this.colorScales = await this._colorScaleService.getColorScales();

    if (this.formGroupContainer.get('scale_id')?.value) {
      const existingColorScale = await this._colorScaleService.findColorScaleById(this.formGroupContainer.get('scale_id')?.value!);
      this.colorScaleControl.patchValue(existingColorScale!);
    }

    this._setupColorScaleListeners();
  }

  private _setupColorScaleListeners() {
    this.filteredColorScales = this.colorScaleControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value!.name;
        return this._filter(name);
      })
    );
  }

  selectColorScale(event: MatAutocompleteSelectedEvent) {
    let selectedScale = event.option.value as ColorScale;

    this.formGroupContainer.patchValue({
      scale_id: selectedScale.id
    });
    this.formGroupContainer.markAsDirty();
  }

  displayColorScale(colorScale: ColorScale): string {
    return colorScale?.name;
  }

  private _filter(value: string) {
    const filterValue = value.toLowerCase();

    return this.colorScales.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  public static createColorScaleFormGroup(color_scale_id?: string, color_scale_invert?: boolean){
    const formGroup = new FormGroup({
      scale_id: new FormControl<string | null>(color_scale_id || null, Validators.required),
      invert: new FormControl<boolean>(color_scale_invert || false)
    });

    return formGroup;
  };
}
